var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSavings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 18.715V70c0 5.523-4.477 10-10 10H49.123c-11.731-5.47-16.867-17.202-17.581-28.366a26.138 26.138 0 01-.108-2.057c.027-.34.04-.68.055-1.029.013-.334.026-.674.053-1.028C32.516 32.288 41.72 16 64.677 16h.758c5.665 0 10.492.992 14.565 2.715z",
    fill: "#8DDDFF",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2 57.856h-3.166c-.571 0-1.034.465-1.034 1.04v11.788c0 .574.463 1.04 1.034 1.04h3.165c.57 0 1.034-.466 1.034-1.04V58.896c0-.575-.463-1.04-1.034-1.04zm9.942-8.34h-3.165c-.571 0-1.034.466-1.034 1.04v20.127c0 .574.463 1.04 1.034 1.04h3.165c.571 0 1.034-.466 1.034-1.04V50.556c0-.574-.463-1.04-1.034-1.04zm9.941-5.793h-3.166c-.57 0-1.033.466-1.033 1.04v25.92c0 .574.463 1.04 1.033 1.04h3.166c.57 0 1.034-.466 1.034-1.04v-25.92c0-.574-.463-1.04-1.034-1.04zm9.943-5.529H54.86c-.57 0-1.034.465-1.034 1.04v31.449c0 .574.463 1.04 1.034 1.04h3.166c.57 0 1.033-.466 1.033-1.04v-31.45c0-.573-.463-1.04-1.033-1.04zm9.94-9.656h-3.165c-.571 0-1.034.466-1.034 1.04v41.104c0 .575.463 1.04 1.034 1.04h3.165c.571 0 1.034-.465 1.034-1.04V29.578c0-.574-.463-1.04-1.034-1.04z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.27 51.843l9.943-8.339L47.242 37.8l9.942-5.53 9.942-9.655",
    stroke: "#8DDDFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.01 53.247a.962.962 0 00.958-.965.962.962 0 00-.959-.966c-.53 0-.96.433-.96.966 0 .533.43.965.96.965zm9.942-8.339c.53 0 .96-.432.96-.965a.962.962 0 00-.96-.966c-.53 0-.96.433-.96.966 0 .533.43.965.96.965zm10.028-5.704c.53 0 .96-.433.96-.966a.962.962 0 00-.96-.965c-.53 0-.96.432-.96.965 0 .533.43.966.96.966zm9.943-5.53c.53 0 .96-.432.96-.965a.962.962 0 00-.96-.966c-.53 0-.96.433-.96.966 0 .533.43.965.96.965zm9.941-9.656c.53 0 .96-.432.96-.965a.962.962 0 00-.96-.966c-.53 0-.96.433-.96.966 0 .533.43.965.96.965z",
    fill: "#8DDDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.01 53.16a.962.962 0 00.958-.966.962.962 0 00-.959-.965c-.53 0-.96.432-.96.965 0 .533.43.966.96.966zm9.942-8.339c.53 0 .96-.432.96-.965a.962.962 0 00-.96-.966c-.53 0-.96.432-.96.965 0 .534.43.966.96.966zm10.028-5.706c.53 0 .96-.433.96-.966a.962.962 0 00-.96-.965c-.53 0-.96.432-.96.965 0 .533.43.966.96.966zm9.943-5.63c.53 0 .96-.432.96-.966a.962.962 0 00-.96-.965c-.53 0-.96.432-.96.965 0 .534.43.966.96.966zm9.941-9.554c.53 0 .96-.432.96-.966a.962.962 0 00-.96-.965c-.53 0-.96.432-.96.965 0 .534.43.966.96.966z",
    stroke: "#8DDDFF",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavings);
export default __webpack_public_path__ + "static/media/savings.8fc852f1b4207003ece0c54ad3e017f0.svg";
export { ForwardRef as ReactComponent };